import { AAGUID } from '@interticket/core';
import { IOnlinePartner } from '@core/interfaces/partner/online-partner.interface';

export class OnlinePartner implements IOnlinePartner {

  readonly activeEventCount: number;
  readonly imageId: AAGUID;
  readonly partnerName: string;
  readonly partnerPageDomain: string;

  constructor(iOnlinePartner: IOnlinePartner) {
    this.activeEventCount = +iOnlinePartner.activeEventCount;
    this.imageId = iOnlinePartner.imageId;
    this.partnerName = iOnlinePartner.partnerName;
    this.partnerPageDomain = iOnlinePartner.partnerPageDomain;
  }

}
